module.exports = __webpack_public_path__ + "logo_sinfondo2016.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_sinfondo2016.png
// module id = 1395
// module chunks = 0